import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import * as Steps from '../views/CheckoutPlans/steps';

import * as routes from '../settings/_routesSettings';

const CheckoutPlansRouter = () => (
  <Switch>
    <Redirect exact from={routes.CHECKOUT_PLANS} to={routes.CHECKOUT_PLANS_FIRST_TIME} />
    <Route path={routes.CHECKOUT_PLANS_FIRST_TIME} component={Steps.FirstTime} />
    <Route path={routes.CHECKOUT_PLANS_MEDICAL_REQUEST} component={Steps.MedicalRequest} />
    <Route path={routes.CHECKOUT_PLANS_DETAILS} component={Steps.Details} />
    <Route path={routes.CHECKOUT_PLANS_CONFIRMATION} component={Steps.Confirmation} />
  </Switch>
);

export default CheckoutPlansRouter;